function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.024 13C.906 13 0 13.728 0 14.627V15h13v-.373c0-.899-.906-1.627-2.025-1.627h-8.95z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 6c0-3.38 2.687-6 6.153-6 1.557 0 2.888.49 3.817 1.176.503.367.728.759.728 1.224 0 .612-.502 1.102-1.205 1.102-.301 0-.628-.122-.98-.367a3.882 3.882 0 00-2.31-.76C5.068 2.376 3.461 3.968 3.461 6c0 2.008 1.607 3.625 3.767 3.625 1.055 0 1.96-.368 2.637-.956.251-.245.628-.44 1.005-.44.653 0 1.13.514 1.13 1.15 0 .295-.126.613-.477 1.005C10.568 11.388 8.886 12 7.153 12 3.687 12 1 9.355 1 6z",
  fill: "#FF6A13"
}));

function SvgSimplifiedLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplifiedLogo);
export default __webpack_public_path__ + "static/media/simplified-logo.75ce96d0.svg";
export { ForwardRef as ReactComponent };